export const pipe = <T>(...funcs: Function[]) => {
  if (!funcs.length) {
    return (a: any): T => a;
  }
  const [fn, ...fs] = funcs;
  const next = pipe<T>(...fs);
  return (...args: any): T => next(fn(...args));
};

export interface CondItem<T> {
  cond: boolean | ((...args: any) => boolean);
  fn: T | ((...args: any) => T);
}

export const cond = <T>(list: CondItem<T>[]) => (...args: any): T | undefined => {
  // eslint-disable-next-line no-restricted-syntax
  for (const { cond, fn } of list) {
    if (
      (typeof cond === 'boolean' && cond)
      || (typeof cond === 'function'
      && cond(...args))
    ) {
      return typeof fn === 'function' ? (fn as any)(...args) : fn;
    }
  }
  return undefined;
};

export const identity = <T = any>(v: T): T => v;

export const reduceTimes = <T = any>(
  fn: (pre: T, index: number) => T,
  ts: number, init?: T,
): T => Array(ts)
    .fill(undefined)
    .reduce((pre, _, index) => fn(pre, index), init);

// @ts-ignore
export declare function times <T = any>(fn: (index: number) => T): (ts: number) => T[];
// @ts-ignore
export declare function times <T = any>(fn: (index: number) => T, ts: number): T[];
export function times<T = any>(fn: (index: number) => T, ts?: number) {
  return ts
    ? Array(ts).fill(undefined)
      .map((_, index) => fn(index))
    : (ts: number) => Array(ts).fill(undefined)
      .map((_, index) => fn(index));
};
